const migrations = {
    0: (state) => {
        return {
            ...state,
        }
    },
}

export default migrations